import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    action: false,
    menuOpen: false,
    contactToggle: false
  },
  mutations: {
    setAction (state, value) {
      state.action = !!(value)
    },
    setMenuOpen (state, value) {
      state.menuOpen = value
    },
    setContactToggle (state, value) {
      state.contactToggle = value
    }
  },
  actions: {
    setMenuOpen ({ commit }, value) {
      // console.log(value)
      commit('setMenuOpen', value)
    },
    setAction ({ commit }, value) {
      // console.log(value)
      commit('setAction', value)
    },
    setContactToggle ({ commit }, value) {
      commit('setContactToggle', value)
    }
  }
})
